/* tslint:disable */
/* eslint-disable */
/**
 * ISO Backend Modules API
 * ISO API for the IBE.
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 *
 * @export
 * @enum {string}
 */
var ApiServiceSelectionType;
(function (ApiServiceSelectionType) {
    ApiServiceSelectionType["SINGLESELECTION"] = "SINGLE_SELECTION";
    ApiServiceSelectionType["MULTIPLESERVICES"] = "MULTIPLE_SERVICES";
    ApiServiceSelectionType["MULTIPLEDAYS"] = "MULTIPLE_DAYS";
    ApiServiceSelectionType["CONSECUTIVEDAYS"] = "CONSECUTIVE_DAYS";
    ApiServiceSelectionType["MULTIPLEPAX"] = "MULTIPLE_PAX";
    ApiServiceSelectionType["RADIOSELECTION"] = "RADIO_SELECTION";
    ApiServiceSelectionType["TIMESLOT"] = "TIME_SLOT";
})(ApiServiceSelectionType || (ApiServiceSelectionType = {}));
function ApiServiceSelectionTypeFromJSON(json) {
    return ApiServiceSelectionTypeFromJSONTyped(json);
}
function ApiServiceSelectionTypeFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
function ApiServiceSelectionTypeToJSON(value) {
    return value;
}

export { ApiServiceSelectionType, ApiServiceSelectionTypeFromJSON, ApiServiceSelectionTypeFromJSONTyped, ApiServiceSelectionTypeToJSON };
//# sourceMappingURL=ApiServiceSelectionType.js.map
